<div class="flex flex-col min-h-screen">
    <div class="flex-grow  lg:pt-2 bg-gray-20 lg:border-b border-gray-300">
        <div class=" container mx-auto lg:mb-20">

            <div class="flex flex-col lg:flex-row mx-auto">
                <div class="w-full">
                    <p class="text-xl text-[var(--charcoal)] mt-4"> Update your shipping address below.
                    </p>
                </div>
            </div>

            <div class="flex flex-col md:gap-4 mx-auto mt-6 ">
                <form *ngIf="!loading" [formGroup]="form" class="lg:mt-6" (ngSubmit)="onSubmit()">
                    <div class="flex flex-col space-y-6 sm:space-y-8">
                        <div>
                            <label for="countryCode" class="font-mulish text-base">Country</label>
                            <p-select id="countryCode" formControlName="countryCode" placeholder=""
                                class="w-full  text-sm" optionLabel="name" optionValue="abbreviation"
                                [options]="countries"></p-select>
                        </div>
                        <div>
                            <label class="font-medium">Shipping Address</label>
                            <input formControlName="address1"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                            <small class="text-red-500 block min-h-[1rem]"
                                [ngClass]="{ 'invisible': !getFieldError('address1')}">
                                {{ getFieldError('address1') || '' }}
                            </small>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row md:gap-8 mt-6">
                        <div class="flex-1">
                            <label for="zipCode">{{labelPostalCode}}</label>
                            <input formControlName="zipCode"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                            <small class="text-red-500 block min-h-[1rem]"
                                [ngClass]="{ 'invisible': !getFieldError('zipCode')}">
                                {{ getFieldError('zipCode') || '' }}
                            </small>
                        </div>
                        <div class="flex-1 mt-6 md:mt-0 lg:mt-0">
                            <label for="city" class="font-mulish text-base">City</label>
                            <input id="city" formControlName="city"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm " />
                            <small class="text-red-500 block min-h-[1rem]"
                                [ngClass]="{ 'invisible': !getFieldError('city')}">
                                {{ getFieldError('city') || '' }}
                            </small>
                        </div>
                    </div>

                    <div class="mt-7 mb-20">
                        <label for="region" class="font-mulish text-base">{{labelState}}</label>

                        <p-select *ngIf="states.length > 0" id="region" formControlName="region" class="w-full text-sm"
                            [options]="states" optionLabel="name" optionValue="abbreviation"
                            placeholder="{{ placeHolderState }}" appendTo="body">
                        </p-select>

                        <input *ngIf="states.length === 0" id="region" formControlName="region"
                            class="p-inputtext w-full border rounded-md px-3 py-2" placeholder="Enter your region" />
                    </div>

                    
                        
                        
                        <div class="flex grid grid-cols-3 gap-x-[30px] gap-y-[15px] mt-[30px] flex-wrap-reverse">
                            <div class="lg:col-span-1 col-span-3 lg:order-0 order-1">
                                <button pButton type="button" [routerLink]="['/my-account']"
                                    class="h-[35px] !font-noto-serif w-full !font-normal"
                                    [outlined]="true">
                                    Back
                                </button>
                            </div>
                            <div class="lg:col-span-2 col-span-3 lg:order-1 order-0">
                                <button pButton 
                                    class="h-[35px] !font-noto-serif w-full" type="submit"
                                    [disabled]="form.invalid ">
                                    {{ defaultCountry ? 'Update' : 'Save' }}
                                </button>
                            </div>
                        </div>
                </form>
            </div>
        </div>
    </div>

    <ng-container *ngIf="loading">


        <div class="fixed inset-0 z-50 flex items-center justify-center min-h-[300px]">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    </ng-container>

</div>